<template>
  <div class="sidebar">
    <div class="sidebar_mains">
      <div class="content">
        <div class="item" @click="go(1)">
          <i class="el-icon-orange"></i>
          <a>官网</a>
        </div>
        <div class="item">
          <i class="el-icon-mobile-phone"></i>
          <a>APP</a>
          <div class="QRCode">
            <img src="@/assets/download.png" />
          </div>
        </div>
        <div class="item" @click="go(2)">
          <i class="el-icon-notebook-1"></i>
          <a>操作手册</a>
        </div>
        <div class="item" @click="go(3)">
          <i class="el-icon-chat-dot-round"></i>
          <a>消息</a>
        </div>
        <div class="item" @click="go(4)">
          <i class="el-icon-top"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    go(type) {
      switch (type) {
        case 1:
          window.open('https://www.sckjxg.com/');
          break;
        case 2:
          this.$router.push({
            path: '/front/info/operate',
          });
          break;
        case 3:
          this.goMessage();
          break;
        case 4:
          this.goTop();
          break;
      }
    },
    goMessage() {
      let token = sessionStorage.getItem('token');
      if (!token) {
        this.$router.push({
          path: '/',
        });
      }
    },
    goTop() {
      const app = document.getElementsByClassName('common-layout')[0];
      app.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style lang="less" scoped>
.sidebar {
  width: 64px;
  position: fixed;
  right: 12%;
  top: 30%;
  z-index: 3;
  .content {
    width: 100%;
    .item {
      width: 100%;
      height: 64px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      margin: 8px 0;
      border-radius: 8px;
      font-size: 30px;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
      position: relative;
      a {
        margin-top: 4px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 15.84px;
        color: rgba(0, 0, 0, 1);
        text-align: left;
        vertical-align: top;
      }
      &:hover {
        .QRCode {
          display: block;
        }
      }
      .QRCode {
        display: none;
        position: absolute;
        width: 130px;
        height: 130px;
        top: 0;
        left: calc(100% + 10px);
        border-radius: 15px;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
        background: #fff;
        box-sizing: border-box;
        padding: 5px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
